"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Input_1 = __importDefault(require("./Input"));
const Icon_1 = __importDefault(require("./Icon"));
const Colors_1 = require("../../Colors");
const react_redux_1 = require("react-redux");
const function_1 = require("../../features/menu/function");
const SearchBar = react_1.default.memo(({ className = 'md', filterData = 'name', handlerFilterList, isMember = false, defaultSearchContent, isIconHide = false, isDisable = false, isTest = false, }) => {
    const searhTextRef = react_1.default.useRef(null);
    const [isFocused, setIsFocused] = react_1.default.useState(false);
    const [textValue, setTextValue] = react_1.default.useState('');
    const menu = (0, react_redux_1.useSelector)((state) => (0, function_1.getMenuData)(state), react_redux_1.shallowEqual);
    const placeholder = menu.depths === 'myRoom'
        ? menu.menu.menu === 'test'
            ? '테스트명을 입력해주세요'
            : '과제명을 입력해주세요'
        : isMember
            ? '성명 검색'
            : '검색어를 입력해주세요';
    const onSubmit = () => {
        if (!isIconHide) {
            handlerFilterList(textValue === '' ? { [filterData]: undefined } : { [filterData]: textValue });
        }
    };
    (0, react_1.useEffect)(() => {
        if (isIconHide) {
            handlerFilterList(textValue === '' ? { [filterData]: undefined } : { [filterData]: textValue });
        }
    }, [isIconHide, textValue, filterData]);
    (0, react_1.useEffect)(() => {
        return () => {
            if (searhTextRef.current)
                searhTextRef.current.value = '';
            setTextValue('');
        };
    }, [isTest]);
    // 검색어 초기화(dropDown 변경 시)
    (0, react_1.useEffect)(() => {
        setTextValue('');
    }, [isDisable]);
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    const getSize = () => {
        if (className.includes('sm')) {
            return 20;
        }
        else if (className.includes('lg')) {
            return 28;
        }
        return 24;
    };
    (0, react_1.useEffect)(() => {
        if (searhTextRef.current) {
            searhTextRef.current.value = defaultSearchContent || '';
            setTextValue(defaultSearchContent || '');
        }
    }, [defaultSearchContent]);
    return (react_1.default.createElement("div", { className: `flex row search-bar ${className} ${isFocused && 'focus'}` },
        react_1.default.createElement(Input_1.default, { ref: searhTextRef, type: "text", placeholder: placeholder, isEnterPrevent: true, onChange: setTextValue, onSubmit: onSubmit, onFocus: handleFocus, onBlur: handleBlur, value: isDisable ? '' : textValue, isDisable: isDisable }),
        !isIconHide && (react_1.default.createElement("div", { className: "flex row icon", onClick: onSubmit },
            react_1.default.createElement(Icon_1.default, { icon: "search", size: getSize(), fill: Colors_1.Colors.tur })))));
});
exports.default = SearchBar;
